/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AppointmentConcernModal } from './AppointmentConcernModal';
import {
    AppointmentConcernModalFromJSON,
    AppointmentConcernModalFromJSONTyped,
    AppointmentConcernModalToJSON,
} from './AppointmentConcernModal';
import type { AppointmentConcernRestriction } from './AppointmentConcernRestriction';
import {
    AppointmentConcernRestrictionFromJSON,
    AppointmentConcernRestrictionFromJSONTyped,
    AppointmentConcernRestrictionToJSON,
} from './AppointmentConcernRestriction';
import type { AppointmentDeliveryOption } from './AppointmentDeliveryOption';
import {
    AppointmentDeliveryOptionFromJSON,
    AppointmentDeliveryOptionFromJSONTyped,
    AppointmentDeliveryOptionToJSON,
} from './AppointmentDeliveryOption';
import type { BookingOptionFee } from './BookingOptionFee';
import {
    BookingOptionFeeFromJSON,
    BookingOptionFeeFromJSONTyped,
    BookingOptionFeeToJSON,
} from './BookingOptionFee';
import type { FollowUpConcern } from './FollowUpConcern';
import {
    FollowUpConcernFromJSON,
    FollowUpConcernFromJSONTyped,
    FollowUpConcernToJSON,
} from './FollowUpConcern';
import type { PatientClearance } from './PatientClearance';
import {
    PatientClearanceFromJSON,
    PatientClearanceFromJSONTyped,
    PatientClearanceToJSON,
} from './PatientClearance';
import type { TimeInterval } from './TimeInterval';
import {
    TimeIntervalFromJSON,
    TimeIntervalFromJSONTyped,
    TimeIntervalToJSON,
} from './TimeInterval';

/**
 * 
 * @export
 * @interface AppointmentConcern
 */
export interface AppointmentConcern {
    /**
     * 
     * @type {string}
     * @memberof AppointmentConcern
     */
    id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AppointmentConcern
     */
    disabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AppointmentConcern
     */
    text: string;
    /**
     * 
     * @type {number}
     * @memberof AppointmentConcern
     */
    minutes: number;
    /**
     * 
     * @type {number}
     * @memberof AppointmentConcern
     */
    capacity_duration_minutes?: number;
    /**
     * 
     * @type {number}
     * @memberof AppointmentConcern
     */
    max_simultaneous_appointments?: number;
    /**
     * Id of a ClinicInfo.booking_resources entry this concern occupies. When set, the slot engine caps overlapping appointments sharing this resource at the clinic's count (capacity_duration_minutes = how long it stays occupied) and ignores supertype/max_simultaneous_appointments for that purpose. Unset = legacy behaviour.
     * @type {string}
     * @memberof AppointmentConcern
     */
    booking_resource_id?: string;
    /**
     * Each listed address receives a daily business-morning email (8:30 tenant-local, Mon-Fri) of upcoming active appointments under this concern, with bookings new since the previous email highlighted. Trimmed, lowercased and de-duplicated on save; every entry must be a valid email. Empty or absent = no digest. On a booking-flow-option write, ABSENT keeps the recipients already stored for that concern id (older clients drop unknown fields); send [] to clear.
     * @type {Array<string>}
     * @memberof AppointmentConcern
     */
    schedule_digest_emails?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof AppointmentConcern
     */
    only_primary_physician?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AppointmentConcern
     */
    no_primary_physician?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AppointmentConcern
     */
    ai_prompt?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AppointmentConcern
     */
    skip_reason?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AppointmentConcern
     */
    reason_text?: string;
    /**
     * Plain-text appended to appointment SMS reminders and to the new-appointment push notification. Plain text only — no markdown.
     * @type {string}
     * @memberof AppointmentConcern
     */
    communication_text?: string;
    /**
     * Markdown rendered into the footer of the new-appointment confirmation email. Independent of communication_text (SMS/push).
     * @type {string}
     * @memberof AppointmentConcern
     */
    email_communication_markdown?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AppointmentConcern
     */
    allow_empty_reason?: boolean;
    /**
     * 
     * @type {AppointmentConcernModal}
     * @memberof AppointmentConcern
     */
    modal?: AppointmentConcernModal;
    /**
     * 
     * @type {Array<BookingOptionFee>}
     * @memberof AppointmentConcern
     */
    fees?: Array<BookingOptionFee>;
    /**
     * Patient-facing sentence explaining a periodic fee (see BookingOptionFee.covered_interval) — why this visit costs what it costs and when it is covered again, e.g. "You had one on March 12, 2025. The next one is covered from March 12, 2027 — until then it's $250." Absent when the concern does not price this patient's plan by period, which includes every flat-fee concern.
     * RESPONSE-ONLY and per patient: server-composed from that patient's own history whenever the booking options are read for someone specific, never stored and never accepted from a client. The date it quotes comes from the same lookup that decides the amount, so a client composing its own would be a second implementation of the rule, free to disagree with the one that charges.
     * @type {string}
     * @memberof AppointmentConcern
     */
    fee_message?: string;
    /**
     * 
     * @type {Array<AppointmentConcernRestriction>}
     * @memberof AppointmentConcern
     */
    restrictions?: Array<AppointmentConcernRestriction>;
    /**
     * 
     * @type {number}
     * @memberof AppointmentConcern
     */
    above_age_months?: number;
    /**
     * 
     * @type {number}
     * @memberof AppointmentConcern
     */
    below_age_months?: number;
    /**
     * 
     * @type {string}
     * @memberof AppointmentConcern
     */
    gender?: AppointmentConcernGenderEnum;
    /**
     * 
     * @type {boolean}
     * @memberof AppointmentConcern
     */
    annual?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AppointmentConcern
     */
    not_first_appointment?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AppointmentConcern
     */
    supertype?: string;
    /**
     * 
     * @type {string}
     * @memberof AppointmentConcern
     */
    unable_to_book_message?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AppointmentConcern
     */
    skills?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AppointmentConcern
     */
    clinics?: Array<string>;
    /**
     * DEPRECATED — practitioner types by LABEL. Superseded by staff_roles, which references StaffRole ids so a tenant can rename a role without silently breaking which practitioners this concern matches. Read as a fallback while staff_roles is unset.
     * @type {Array<string>}
     * @memberof AppointmentConcern
     */
    physician_types?: Array<string>;
    /**
     * StaffRole ids allowed to take this concern. Empty or absent = no role restriction. Takes precedence over physician_types.
     * @type {Array<string>}
     * @memberof AppointmentConcern
     */
    staff_roles?: Array<string>;
    /**
     * 
     * @type {FollowUpConcern}
     * @memberof AppointmentConcern
     */
    follow_up_concern?: FollowUpConcern;
    /**
     * 
     * @type {string}
     * @memberof AppointmentConcern
     */
    color_on_schedule?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AppointmentConcern
     */
    hidden_from_patient?: boolean;
    /**
     * How long until the appointment is automaically marked no show
     * @type {number}
     * @memberof AppointmentConcern
     */
    cancel_cutoff?: number;
    /**
     * Per-concern override (hours) for the cancellation/credit window. Overrides the tenant default_refund_window_hours. Clamped 0..168 server-side. Unset => the tenant default applies.
     * @type {number}
     * @memberof AppointmentConcern
     */
    refund_window_hours?: number;
    /**
     * Minutes to block on the schedule before the appointment
     * (setup, equipment cleaning, travel). Unset => the type default
     * (home visits block 30, everything else 0).
     * @type {number}
     * @memberof AppointmentConcern
     */
    blocked_minutes_before?: number;
    /**
     * Minutes to block on the schedule after the appointment.
     * Unset => the type default (home visits block 30, everything else 0).
     * @type {number}
     * @memberof AppointmentConcern
     */
    blocked_minutes_after?: number;
    /**
     * 
     * @type {Array<AppointmentDeliveryOption>}
     * @memberof AppointmentConcern
     */
    delivery_options?: Array<AppointmentDeliveryOption>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AppointmentConcern
     */
    requirements?: Array<string>;
    /**
     * 
     * @type {TimeInterval}
     * @memberof AppointmentConcern
     */
    minimum_interval?: TimeInterval;
    /**
     * Clearances granted to patient upon appointment completion. Duplicated clearances are overwritten.
     * @type {Array<PatientClearance>}
     * @memberof AppointmentConcern
     */
    grants_clearances?: Array<PatientClearance>;
    /**
     * Optional override for the invoice line item name. If set, used instead of the default "[Type] Appointment" label.
     * @type {string}
     * @memberof AppointmentConcern
     */
    invoice_item_name?: string;
    /**
     * Short alphanumeric code used as prefix for Stripe invoice numbers. Auto-generated on concern save if not set.
     * @type {string}
     * @memberof AppointmentConcern
     */
    invoice_code?: string;
    /**
     * When true, booking does not charge the patient. The resolved fee is recorded on the appointment as pending_fee and charged later via the chargeAppointment endpoint.
     * @type {boolean}
     * @memberof AppointmentConcern
     */
    manual_charge?: boolean;
    /**
     * patient filled document sent to the patient upon booking
     * @type {string}
     * @memberof AppointmentConcern
     */
    patient_filled_document?: string;
}


/**
 * @export
 */
export const AppointmentConcernGenderEnum = {
    Male: 'Male',
    Female: 'Female'
} as const;
export type AppointmentConcernGenderEnum = typeof AppointmentConcernGenderEnum[keyof typeof AppointmentConcernGenderEnum];


/**
 * Check if a given object implements the AppointmentConcern interface.
 */
export function instanceOfAppointmentConcern(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "text" in value;
    isInstance = isInstance && "minutes" in value;

    return isInstance;
}

export function AppointmentConcernFromJSON(json: any): AppointmentConcern {
    return AppointmentConcernFromJSONTyped(json, false);
}

export function AppointmentConcernFromJSONTyped(json: any, ignoreDiscriminator: boolean): AppointmentConcern {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'disabled': !exists(json, 'disabled') ? undefined : json['disabled'],
        'text': json['text'],
        'minutes': json['minutes'],
        'capacity_duration_minutes': !exists(json, 'capacity_duration_minutes') ? undefined : json['capacity_duration_minutes'],
        'max_simultaneous_appointments': !exists(json, 'max_simultaneous_appointments') ? undefined : json['max_simultaneous_appointments'],
        'booking_resource_id': !exists(json, 'booking_resource_id') ? undefined : json['booking_resource_id'],
        'schedule_digest_emails': !exists(json, 'schedule_digest_emails') ? undefined : json['schedule_digest_emails'],
        'only_primary_physician': !exists(json, 'only_primary_physician') ? undefined : json['only_primary_physician'],
        'no_primary_physician': !exists(json, 'no_primary_physician') ? undefined : json['no_primary_physician'],
        'ai_prompt': !exists(json, 'ai_prompt') ? undefined : json['ai_prompt'],
        'skip_reason': !exists(json, 'skip_reason') ? undefined : json['skip_reason'],
        'reason_text': !exists(json, 'reason_text') ? undefined : json['reason_text'],
        'communication_text': !exists(json, 'communication_text') ? undefined : json['communication_text'],
        'email_communication_markdown': !exists(json, 'email_communication_markdown') ? undefined : json['email_communication_markdown'],
        'allow_empty_reason': !exists(json, 'allow_empty_reason') ? undefined : json['allow_empty_reason'],
        'modal': !exists(json, 'modal') ? undefined : AppointmentConcernModalFromJSON(json['modal']),
        'fees': !exists(json, 'fees') ? undefined : ((json['fees'] as Array<any>).map(BookingOptionFeeFromJSON)),
        'fee_message': !exists(json, 'fee_message') ? undefined : json['fee_message'],
        'restrictions': !exists(json, 'restrictions') ? undefined : ((json['restrictions'] as Array<any>).map(AppointmentConcernRestrictionFromJSON)),
        'above_age_months': !exists(json, 'above_age_months') ? undefined : json['above_age_months'],
        'below_age_months': !exists(json, 'below_age_months') ? undefined : json['below_age_months'],
        'gender': !exists(json, 'gender') ? undefined : json['gender'],
        'annual': !exists(json, 'annual') ? undefined : json['annual'],
        'not_first_appointment': !exists(json, 'not_first_appointment') ? undefined : json['not_first_appointment'],
        'supertype': !exists(json, 'supertype') ? undefined : json['supertype'],
        'unable_to_book_message': !exists(json, 'unable_to_book_message') ? undefined : json['unable_to_book_message'],
        'skills': !exists(json, 'skills') ? undefined : json['skills'],
        'clinics': !exists(json, 'clinics') ? undefined : json['clinics'],
        'physician_types': !exists(json, 'physician_types') ? undefined : json['physician_types'],
        'staff_roles': !exists(json, 'staff_roles') ? undefined : json['staff_roles'],
        'follow_up_concern': !exists(json, 'follow_up_concern') ? undefined : FollowUpConcernFromJSON(json['follow_up_concern']),
        'color_on_schedule': !exists(json, 'color_on_schedule') ? undefined : json['color_on_schedule'],
        'hidden_from_patient': !exists(json, 'hidden_from_patient') ? undefined : json['hidden_from_patient'],
        'cancel_cutoff': !exists(json, 'cancel_cutoff') ? undefined : json['cancel_cutoff'],
        'refund_window_hours': !exists(json, 'refund_window_hours') ? undefined : json['refund_window_hours'],
        'blocked_minutes_before': !exists(json, 'blocked_minutes_before') ? undefined : json['blocked_minutes_before'],
        'blocked_minutes_after': !exists(json, 'blocked_minutes_after') ? undefined : json['blocked_minutes_after'],
        'delivery_options': !exists(json, 'delivery_options') ? undefined : ((json['delivery_options'] as Array<any>).map(AppointmentDeliveryOptionFromJSON)),
        'requirements': !exists(json, 'requirements') ? undefined : json['requirements'],
        'minimum_interval': !exists(json, 'minimum_interval') ? undefined : TimeIntervalFromJSON(json['minimum_interval']),
        'grants_clearances': !exists(json, 'grants_clearances') ? undefined : ((json['grants_clearances'] as Array<any>).map(PatientClearanceFromJSON)),
        'invoice_item_name': !exists(json, 'invoice_item_name') ? undefined : json['invoice_item_name'],
        'invoice_code': !exists(json, 'invoice_code') ? undefined : json['invoice_code'],
        'manual_charge': !exists(json, 'manual_charge') ? undefined : json['manual_charge'],
        'patient_filled_document': !exists(json, 'patient_filled_document') ? undefined : json['patient_filled_document'],
    };
}

export function AppointmentConcernToJSON(value?: AppointmentConcern | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'disabled': value.disabled,
        'text': value.text,
        'minutes': value.minutes,
        'capacity_duration_minutes': value.capacity_duration_minutes,
        'max_simultaneous_appointments': value.max_simultaneous_appointments,
        'booking_resource_id': value.booking_resource_id,
        'schedule_digest_emails': value.schedule_digest_emails,
        'only_primary_physician': value.only_primary_physician,
        'no_primary_physician': value.no_primary_physician,
        'ai_prompt': value.ai_prompt,
        'skip_reason': value.skip_reason,
        'reason_text': value.reason_text,
        'communication_text': value.communication_text,
        'email_communication_markdown': value.email_communication_markdown,
        'allow_empty_reason': value.allow_empty_reason,
        'modal': AppointmentConcernModalToJSON(value.modal),
        'fees': value.fees === undefined ? undefined : ((value.fees as Array<any>).map(BookingOptionFeeToJSON)),
        'fee_message': value.fee_message,
        'restrictions': value.restrictions === undefined ? undefined : ((value.restrictions as Array<any>).map(AppointmentConcernRestrictionToJSON)),
        'above_age_months': value.above_age_months,
        'below_age_months': value.below_age_months,
        'gender': value.gender,
        'annual': value.annual,
        'not_first_appointment': value.not_first_appointment,
        'supertype': value.supertype,
        'unable_to_book_message': value.unable_to_book_message,
        'skills': value.skills,
        'clinics': value.clinics,
        'physician_types': value.physician_types,
        'staff_roles': value.staff_roles,
        'follow_up_concern': FollowUpConcernToJSON(value.follow_up_concern),
        'color_on_schedule': value.color_on_schedule,
        'hidden_from_patient': value.hidden_from_patient,
        'cancel_cutoff': value.cancel_cutoff,
        'refund_window_hours': value.refund_window_hours,
        'blocked_minutes_before': value.blocked_minutes_before,
        'blocked_minutes_after': value.blocked_minutes_after,
        'delivery_options': value.delivery_options === undefined ? undefined : ((value.delivery_options as Array<any>).map(AppointmentDeliveryOptionToJSON)),
        'requirements': value.requirements,
        'minimum_interval': TimeIntervalToJSON(value.minimum_interval),
        'grants_clearances': value.grants_clearances === undefined ? undefined : ((value.grants_clearances as Array<any>).map(PatientClearanceToJSON)),
        'invoice_item_name': value.invoice_item_name,
        'invoice_code': value.invoice_code,
        'manual_charge': value.manual_charge,
        'patient_filled_document': value.patient_filled_document,
    };
}

